import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, dt } from "@/lib/api";
import { PageHeader, Card, Table, StatusBadge, Money, Sel } from "@/components/common";
import { PayDialog } from "@/pages/PurchaseDetail";
import { useAuth } from "@/context/AuthContext";

export default function Payables() {
  const { meta, loadMeta } = useAuth();
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [sup, setSup] = useState("");
  const [showPaid, setShowPaid] = useState(false);
  const [pay, setPay] = useState(null);
  const load = () => api.get("/payables").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const list = rows.filter((r) => (!sup || r.supplier_id === sup) && (showPaid || r.outstanding > 0.01));
  const bySup = Object.values(rows.filter((r) => r.outstanding > 0.01).reduce((m, r) => { (m[r.supplier_id] ||= { name: r.supplier_name, v: 0, n: 0 }).v += r.outstanding; m[r.supplier_id].n += 1; return m; }, {}));
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div>
      <PageHeader title="Hutang supplier (kasbon)" sub="Pembelian dengan metode bayar hutang. Barang bisa sudah diterima walau belum dibayar. Klik baris untuk detail, atau Bayar per invoice.">
        <Sel className="!w-56" testid="payables-supplier-filter" value={sup} onChange={setSup} placeholder="Semua supplier" options={meta.suppliers.map((s) => ({ value: s.id, label: s.name }))} />
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={showPaid} onChange={(e) => setShowPaid(e.target.checked)} /> Tampilkan lunas</label>
      </PageHeader>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {bySup.map((s) => <div key={s.name} className="bg-white border rounded-lg p-3"><div className="text-[11px] uppercase font-semibold text-slate-500 truncate">{s.name}</div><Money v={s.v} className="text-lg font-bold" /><div className="text-[11px] text-slate-500">{s.n} invoice</div></div>)}
        {bySup.length === 0 && <div className="text-sm text-slate-500">Tidak ada hutang berjalan.</div>}
      </div>
      <Card>
        <Table testid="payables-table" rows={list} onRow={(r) => nav(`/purchases/${r.id}`)} cols={[
          { h: "Kode", r: (r) => <span className="num text-xs font-semibold text-emerald-700">{r.code}</span> }, { h: "Tanggal", k: "date" }, { h: "Supplier", k: "supplier_name" },
          { h: "Invoice", k: "invoice_no" }, { h: "Jatuh tempo", r: (r) => <span className={r.due_date && r.due_date <= today && r.outstanding > 0 ? "text-rose-600 font-semibold" : ""}>{r.due_date || "-"}</span> },
          { h: "Total", right: true, r: (r) => <Money v={r.total} /> }, { h: "Dibayar", right: true, r: (r) => <Money v={r.paid_amount || 0} /> },
          { h: "Sisa", right: true, r: (r) => <Money v={r.outstanding} className="font-bold" /> },
          { h: "Status", r: (r) => <span className="flex gap-1"><StatusBadge s={r.payment_status} /><StatusBadge s={r.status} /></span> },
          { h: "Dibuat", r: (r) => <span className="text-xs">{r.created_by.name} · {dt(r.created_at)}</span> },
          { h: "", r: (r) => r.outstanding > 0.01 ? <button onClick={(e) => { e.stopPropagation(); setPay({ p: r, v: { account_id: "", amount: r.outstanding, note: "" } }); }} className="text-xs font-semibold text-emerald-700 hover:underline" data-testid={`pay-${r.code}`}>Bayar</button> : null },
        ]} />
      </Card>
      {pay && <PayDialog p={pay.p} pay={pay.v} setPay={(v) => setPay(v ? { ...pay, v } : null)} onDone={() => { setPay(null); load(); loadMeta(); }} />}
    </div>
  );
}
